import { fontSizes } from "healthex-common/sizes";
import styled, { css } from "styled-components";
import MuiAvatar from "@mui/material/Avatar";
export const Avatar = styled(MuiAvatar) `
    width: ${(props) => { var _a; return (_a = props.dimensions) !== null && _a !== void 0 ? _a : 32; }}px;
    height: ${(props) => { var _a; return (_a = props.dimensions) !== null && _a !== void 0 ? _a : 32; }}px;
    line-height: ${(props) => { var _a; return (_a = props.dimensions) !== null && _a !== void 0 ? _a : 32; }}px;
    font-size: ${(props) => { var _a; return (_a = props.fontSize) !== null && _a !== void 0 ? _a : fontSizes.SMALL; }};

    ${(props) => props.children !== null &&
    css `
            background-color: ${props.color};
        `}

    ${(props) => props.onClick &&
    css `
            cursor: pointer;
        `}

   ${(props) => props.disabled &&
    css `
            filter: grayscale(1);
        `}
`;
